import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import notificationService from "@/services/notification.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type Return = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveNotification = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (notificationId) => notificationService.delete(notificationId),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemoveNotification;
